// import type BottomMenuComponent from "@/components/Templates/UI/BottomMenuComponent.vue";
import Global from "@/ts/Global";
import BackgroundScript from "./BackgroundScript";
import Base from "./Base";
import Menu from "./Menu";
import PageBase from "./PageBase";

/**
 * 通用传参结构体
 */
export default class GeneralObjVO {
    /**
     * 总也列表
     */
    PageDrawComponent: PageBase[] = [];
    private _IsPlayer: boolean = false;

    /**
     * 是否正在播放
     */
    public get IsPlayer(): boolean {
        return this._IsPlayer;
    }

    public set IsPlayer(v: boolean) {
        this._IsPlayer = v;
    }

    /**
     * 是否横屏
     */
    private isLandscape: boolean = false;//是否横屏 


    public get IsLandscape(): boolean {
        return this.isLandscape;
    }


    public set IsLandscape(v: boolean) {
        this.isLandscape = v;
    }

    /**
     * 是否为编辑模式
     */
    IsEditMode = true; //是否为编辑模式
    /**
     * 当前页
     */
    private _CurrentPageIndex: number = 0;


    public get CurrentPageIndex(): number {
        return this._CurrentPageIndex;
    }

    public set CurrentPageIndex(v: number) {
        this._CurrentPageIndex = v;
    }



    /**
     * 当前背景
     */
    CurrentBackground?: BackgroundScript;
    /**
     * 是否显示背景
     */
    ShowCurrentBackground: boolean = false;
    /**
     * 当前组件
     */
    CurrentBase?: Base;
    /**
     * 当前菜单
     */
    Menu?: Menu;
    /**
     * 设置当前选择的组件
     */
    SetCurrentBase?: (b: Base) => void;
    /**
     * 底部菜单组件
     */
    BottomMenuRef?: any;
    /**
     * 总时间
     */
    private _TotalMilliseconds: number = 0;

    public get TotalMilliseconds(): number {
        return this._TotalMilliseconds;
    }

    public set TotalMilliseconds(v: number) {
        this._TotalMilliseconds = v;
    }


    /**
     * 当前时间
     */
    private _CurrentMilliseconds: number = 0;

    public get CurrentMilliseconds(): number {
        return this._CurrentMilliseconds;
    }

    public set CurrentMilliseconds(v: number) {
        this._CurrentMilliseconds = v;
    }


    constructor() {

    }
    /**
     * 播放
     */
    public ToPlay() {
        Global.LastTime = 0;
        this.IsPlayer = true;
        requestAnimationFrame(this.PlayerRun.bind(this));
    }

    /**
     * 暂停
     */
    public ToPause() {
        this.IsPlayer = false;
    }

    /**
     * 停止(进度条归零)
     */
    public ToStop() {
        this.CurrentMilliseconds = -999;
        this.IsPlayer = false;
    }

    /**
     * 运行
     */
    private PlayerRun(timestamp: number) {
        do {
            if (!this.IsPlayer)
                return;
            if (Global.LastTime <= 0) {
                Global.LastTime = timestamp;
                break;
            }
            const runTimer = timestamp - Global.LastTime;
            Global.GeneralObj.value.CurrentMilliseconds += runTimer;
            if (Global.GeneralObj.value.CurrentMilliseconds >= Global.GeneralObj.value.TotalMilliseconds) {
                Global.GeneralObj.value.CurrentMilliseconds = Global.GeneralObj.value.TotalMilliseconds;
                this.ToPause();
                return;
            }
            Global.LastTime = timestamp;
        }
        while (false);
        requestAnimationFrame(this.PlayerRun.bind(this));
    }

    /**
     * 停止
     */
    // public ToStop() {
    //     this.IsPlayer = false;
    //     this.CurrentMilliseconds = 0;
    // }
}